import { useReducer } from 'react';

const defaultToggleFunction = (value) => !value;
/**
 * Use toggle hook helps you easily toggle a value
 *
 * @param initialValue Initial value of the toggle, which will be false if not provided.
 * @param toggleFunction A toggle function. This allows for non boolean toggles
 * @example
 * const [value, toggle] = useToggle("on", _value => _value === "on" ? "off" : "on");
 * // value is "on"
 * // toggle() will change value to "off". Calling it again will change value to "on".
 */
function useToggle(initialValue = false, toggleFunction = defaultToggleFunction) {
    return useReducer(toggleFunction, initialValue);
}

export { useToggle };
